import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ onSuccess, onError, loading = false }) => {
  const handleSuccess = (credentialResponse) => {
    const { credential } = credentialResponse;
    if (credential) {
      onSuccess(credential);
    } else {
      onError(new Error('No credential received from Google'));
    }
  };

  const handleError = () => {
    onError(new Error('Google login failed'));
  };

  return (
    <div className="google-button-wrapper">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        disabled={loading}
        size="large"
        theme="outline"
        shape="rectangular"
        logo_alignment="left"
        text="signin_with"
        locale="pt-BR"
      />

      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <span>Verificando credenciais...</span>
        </div>
      )}
    </div>
  );
};

export default GoogleLoginButton;